<script>
  import BoardField from './BoardField.svelte';
  import { game } from '../store/store';

  function axisCount(fields) {
    // calculate counts for main and cross axis
    const n = fields.length;
    let axisMainCount = parseInt(Math.sqrt(n));
    const axisCrossCount = (axisMainCount > 0 ? axisMainCount : 0);
    const axisCrossN = Array(axisCrossCount);
    if (axisMainCount * axisCrossCount < n) {
      const leftCount = n - axisMainCount * axisCrossCount;
      const axisMainAddCount = parseInt((leftCount - 1) / axisCrossCount) + 1;
      axisMainCount += axisMainAddCount;      
    }
    const axisMainN = Array(axisMainCount);    

    return {
      axisMainCount,
      axisMainN,
      axisCrossCount,
      axisCrossN,
    };   
  }

  $: console.log('Board - game', $game);
  const { axisMainCount, axisMainN, axisCrossCount, axisCrossN } = axisCount($game.board.fields);
</script>

{#if !$game.isComplete}
  {#each axisMainN as _, i}
    <div class="field-line">
      {#each axisCrossN as _, j}
        {#if i*axisCrossCount + j < $game.board.fields.length}
          <BoardField boardField={$game.board.fields[i*axisCrossCount + j]} ind={i*axisCrossCount + j} />
        {:else}
          <div class="board-field-space">&nbsp;</div>
        {/if}
      {/each}
    </div>
  {/each}
{:else}
  <h2 style="text-align: center; line-height: 2em;">
    Game Over!<br />
    Winner:<br />
    {#each $game.playerMaxScore as player}
      {player.name} - {player.score}
    {/each}
  </h2>
{/if}

<style>
.field-line {
  display: flex;
  flex-direction: column;
}

@media only screen and (min-width: 1000px) {
  .field-line {
    flex-direction: row;
  }

}
.field-line:nth-child(2n) {
  justify-content: space-around;
}

.field-line:nth-child(2n+1) {
  justify-content: space-around;
  /* justify-content: space-between; */
}

.board-field-space {
  min-height: 15%; 
  font-size: 1em;
}

@media only screen and (min-width: 1000px) {
  .board-field-space {
    min-width: 10%; 
    min-height: auto; 
  }

}

</style>